module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/disney-8aed8feecfd27b8c2b7afff93fa6dce9.png";